import { reactive } from 'vue'

const store = {
  state:  reactive({
    topics: [],
    recentResults: [],
    selectedResult: null,
    selectedTopic: null
  }),
  setTopics(allTopics) {
    this.state.topics = allTopics
  },
  setRecentResults(recentResults) {
    this.state.recentResults = recentResults
  },
  setSelectedResult(result) {
    this.state.selectedResult = result
  },
  resetSelectedResult() {
    this.state.selectedResult = null
  },
  setSelectedTopic(topic) {
    this.state.selectedTopic = topic
  },
  resetSelectedTopic() {
    this.state.selectedTopic = null
  },
}

export default store
